import React, { useEffect } from "react";
import MaintenanceItemCard from "./MiniComponents/MaintenanceItemCard";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllStandardMaintenanceItems } from "../../../redux/StandardMaintenanceItemSlice/StandardMaintenanceItemSlice";

export default function MaintenanceItems() {
  const dispatch = useDispatch();
  const { allStandardMaintenanceItems } = useSelector((state) => state.standardMaintenanceItems);

  useEffect(() => {
    dispatch(getAllStandardMaintenanceItems());
  }, [dispatch]);

  return (
    <>
      <div className="main">
        <section className="maintenance-items">
          <div>
            <h1 className="text-white">عناصر الصيانة</h1>
          </div>
          <div className="container-fluid">
            <div className="row justify-content-between align-items-center mb-5 mt-3">
              <div className="col-md-4 d-flex justify-content-md-start justify-content-center mb-3">
                <div className="card py-2 px-3">
                  <p className="mb-0 primary-100">
                    عدد عناصر الصيانة: <span className="primary-100">{allStandardMaintenanceItems?.length || 0}</span>
                  </p>
                </div>
              </div>
              <div className="col-md-4 text-center mb-3">
                <input type="search" placeholder="ابحث ..." className="form-control search" />
              </div>
              <div className="col-md-4 text-md-end text-center">
                <Link className="btn btn-primary text-white" to={"/AddMaintenanceItem"}>
                  إضافة عنصر صيانة
                </Link>
              </div>
            </div>
            <div className="row">
              {allStandardMaintenanceItems &&
                allStandardMaintenanceItems.map((item) => (
                  <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-3">
                    <MaintenanceItemCard key={item.id} item={item} />
                  </div>
                ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
